
import { Injectable, NgZone } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, UrlSegment } from '@angular/router';
import { NavController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { endpoints } from '../constant/endpoints';
import { ApiService } from '../provider/api.service';
import { AuthService } from '../services/auth.service';
import { Events } from '../provider/events.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private ngZone: NgZone,
        private router: Router,
        private events: Events,
        private navCtrl: NavController,
        private apiService: ApiService,
        private authService: AuthService,
        private toastCtrl: ToastController,
        private translate: TranslateService
    ) {
    }
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        if (window.localStorage.getItem('auth-token') !== 'null' &&
            window.localStorage.getItem('auth-token') != null &&
            window.localStorage.getItem('auth-verify') != 'false'
        ) {
            return true;
        } else {
            this.events.publish('user:login', { user: null, time: new Date() });
            this.toastCtrl.create({
                message: this.translate.instant('login_to_access_app'),
                duration: 4000,
                position: 'top',
                color: 'primary'
            }).then(toastElem => toastElem.present());
            return false;
        }
    }
    canLoad = async (route: Route) => {
        //console.log(route);
        if (this.authService.getAuthToken() === null
            || this.authService.getAuthVerify() === null
            || this.authService.getAuthVerify() === 'false'
        ) {
            this.ngZone.run(() => {
                this.events.publish('user:login', { user: null, time: new Date() });
            });
            return false;
        } else {
            /*await this.apiService
                .get(endpoints.mySubscriptions)
                .pipe(first())
                .subscribe(result => {
                    let subscription = result.payload.active.length == 0
                        ? (result.payload.upcoming.length == 0
                            ? result.payload.active.length
                            : result.payload.upcoming.length)
                        : result.payload.active.length;

                    console.log('subscription: ', subscription);
                    if (subscription == 0) {
                        this.router.navigateByUrl('/subscription-list');
                        return false;
                    } else {
                        return true;
                    }
                });*/
        }
    }
}
